import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './index.css';

const AcessoRestrito = () => {
  const navigate = useNavigate();

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5521972853889', '_blank'); // Substitua pelo número da Humanize
  };

  return (
    <div className="restricted-access-container">
      <Modal show={true} centered>
        <Modal.Header>
          <Modal.Title>Acesso Restrito</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Para sublocar uma sala, é necessário que você esteja cadastrado no sistema. Entre em contato com a Humanize 
            enviando uma foto do seu documento do conselho para que seu cadastro seja realizado.
          </p>
          <p className="mt-3">
            Já possui cadastro? <span onClick={() => navigate('/login')} className="login-link">Entrar.</span>
          </p>
          <div className="d-flex justify-content-center mt-4">
            <Button variant="success" onClick={handleWhatsAppClick}>
              Entrar em Contato via WhatsApp
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AcessoRestrito;
